import React, { useState } from 'react';

import type { FactComponent } from '../../../../../core/data-sources/content-components/types.js';

import { frontendConfig } from '../../../../../core/system/config/frontend.server.js';
import { useByfunnPulseContext } from '../../../../pulse/index.js';
import Text from '../articleComponents/Text/Text.js';

const FactBox: React.FC<FactComponent> = ({ title, paragraphs }) => {
  const [open, setOpen] = useState(false);
  const { trackClickUIElement } = useByfunnPulseContext();

  const handleOnClick = () => {
    trackClickUIElement(
      {
        object: {
          id: `article:factbox-button-${open ? 'close' : 'open'}`,
          name: 'Factbox button',
          elementType: 'Button',
        },
      },
      {
        object: {
          objectId: `factbox-button-${open ? 'close' : 'open'}`,
          name: 'Factbox button',
          elementType: 'Button',
        },
        placement: { containerName: 'page' },
      },
    );

    setOpen(!open);
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      handleOnClick();
    }
  };

  return (
    <section
      className="fact-box"
      onClick={handleOnClick}
      onKeyDown={handleKeyDown}
      tabIndex={0}
      role="button"
    >
      <div className="fact-header">
        <div className="title-wrapper">
          <h3 className="fact-title-intro">FAKTA</h3>
          {title && <h4 className="fact-title-text">{title.value}</h4>}
        </div>
      </div>
      {paragraphs && (
        <div className={open ? 'fact-content open' : 'fact-content'}>
          <Text paragraphs={paragraphs} type="text" isFact />
        </div>
      )}
      <div className="arrow">
        <img
          className={open ? '' : 'closed'}
          src={`${frontendConfig.cdnUrlInternal}/ap/images/functional_icons/bundle_arrows/arrow_forward_black_24dp.svg`}
          alt="åpne faktaboks"
        />
      </div>
    </section>
  );
};

export default FactBox;
